import React from 'react';
import { useFormContext } from 'react-hook-form';

import { LbDatePicker } from '@infoods/lifebase-ui';

import classes from './ImportantDatesStep.module.scss';
import { ChallengeFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import { useImportantDatesForm } from '../../../../../../hooks/useImportantDatesForm';

type Props = {
  onNext: () => void | Promise<void>;
};

const ImportantDatesStep = ({ onNext }: Props) => {
  const { control, trigger } = useFormContext<ChallengeFormValues>();
  const {
    challengeMinStartDate,
    challengeMaxStartDate,
    challengeMinEndDate,
    registrationMaxStartDate,
  } = useImportantDatesForm('EDIT');

  const generalInputProps = {
    control,
    size: 'small',
    variant: 'standard',
  } as const;

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await trigger([
      'importantDates.startDate',
      'importantDates.endDate',
      'importantDates.registrationStartDate',
    ]);

    if (isValid) {
      await onNext();
    }
  };

  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate className={classes.box}>
      <LbDatePicker
        {...generalInputProps}
        name="importantDates.startDate"
        label="Challenge Start Date"
        minDate={challengeMinStartDate}
        maxDate={challengeMaxStartDate}
        rules={{
          required: 'Challenge Start Date is required',
        }}
        helperText="What day will your challenge start?"
      />
      <LbDatePicker
        {...generalInputProps}
        name="importantDates.endDate"
        label="Challenge End Date"
        minDate={challengeMinEndDate}
        rules={{
          required: 'Challenge End Date is required',
        }}
        helperText="What day will your challenge end?"
      />
      <LbDatePicker
        {...generalInputProps}
        name="importantDates.registrationStartDate"
        label="Registration Start Date"
        maxDate={registrationMaxStartDate}
        rules={{
          required: 'Registration Start Date is required',
        }}
        helperText="When do you want to open registration? It will automatically close 7 days after the start of your challenge."
      />
    </form>
  );
};

export { ImportantDatesStep };
